import { IntlShape } from 'react-intl';

export const dictionary = {
    add_to_family_button__text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.profiles.ui.add-to-family-button.3b6a094fbebd275c3a334f555e1be31d',
            defaultMessage: 'Invite to the family',
            description: 'Текст кнопки приглашения в семью',
        }),
    admin_family_add_permission_form__admin: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.admin-family-add.ui.admin-permission-form.7b7bc2512ee1fedcd76bdc68926d4f7b',
            defaultMessage: 'Administrator',
            description: 'Администратор',
        }),
    admin_family_add_permission_form__only_admin: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.admin-family-add.ui.admin-permission-form.fcfecb380c0f126e150722e79cffa0b9',
            defaultMessage: 'Only the administrator can invite members to the family',
            description: 'Приглашать в семью может только администратор',
        }),
    admin_family_add_permission_form__login: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.admin-family-add.ui.admin-permission-form.bffe9a3c9a7e00ba00a11749e022d911',
            defaultMessage: 'Log in',
            description: 'Текст кнопки авторизации',
        }),

    admin_family_add_permission_form__cancel: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.admin-family-add.ui.admin-permission-form.ea4788705e6873b424c65e91c2846b19',
            defaultMessage: 'Cancel',
            description: 'Текст кнопки отмены',
        }),
    profiles_movie_announce_page__choose: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.profiles.ui.profiles-movie-announce-page.a174b83f9fbcda69097126d4367530dd',
            defaultMessage: 'Choose an account',
            description: 'Подзаголовок страницы выбора профиля c анонсами',
        }),
    profiles_movie_announce_page__not_again: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.profiles.ui.profiles-movie-announce-page.55c2eefc919fb18f2b77bc28a029a5c1',
            defaultMessage: 'Do not ask again',
            description: 'Текст кнопки скрытия выбора профиля',
        }),
    profile_subtext__restricted: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.profiles.utils.284f362107a5b9626a0619f51e2b6a85',
            defaultMessage: 'Restricted video',
            description: 'Текст статуса профиля, если включен родительский контроль',
        }),
    profiles_not_loggin: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.user-profile.09b2c7c552d80033cf8e661b7425a777',
            defaultMessage: 'Not logged in',
            description: 'Описание пользовательского профиля для неавторизованного пользователя',
        }),
    profiles_administrator: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.user-profile.7b7bc2512ee1fedcd76bdc68926d4f7b',
            defaultMessage: 'Administrator',
            description: 'Описание пользовательского профиля для администратора',
        }),
};
